import { render } from "./UpdateGatewayFirmwareForm.vue?vue&type=template&id=78cf7b0e"
import script from "./UpdateGatewayFirmwareForm.vue?vue&type=script&lang=js"
export * from "./UpdateGatewayFirmwareForm.vue?vue&type=script&lang=js"
script.render = render

export default script